import styled, { AnyStyledComponent } from 'styled-components';

interface StyledBaseSVGProps {
    width: number;
};

export const StyledBaseSVG: AnyStyledComponent = styled.svg`
    width: ${({width}: StyledBaseSVGProps) => width}px;
    display: block;
`;
